import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { 
    FiHome, 
    FiUser, 
    FiShoppingCart 
} from "react-icons/fi";
import { BiCategory } from "react-icons/bi";
import { useCart } from "../App"; 

export default function MobileAppBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { cart = [] } = useCart();
    
    // Purani logic ke hisaab se cart count
    const cartItemCount = cart.reduce((total, item) => total + (item.qty || 1), 0);

    const navItems = [
        {
            icon: <FiHome size={22} />,
            label: "Home",
            path: "/"
        },
        {
            icon: <BiCategory size={22} />,
            label: "Categories",
            path: "/categories" // Ab ye us naye Full Page layout ko kholega
        },
        {
            icon: <FiUser size={22} />,
            label: "Account",
            path: "/account"
        },
        {
            icon: (
                <div className="relative">
                    <FiShoppingCart size={22} />
                    {cartItemCount > 0 && (
                        <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                            {cartItemCount > 9 ? '9+' : cartItemCount}
                        </span>
                    )}
                </div>
            ),
            label: "Cart",
            path: "/cart"
        }
    ];

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
            <div className="flex items-center justify-around py-3 px-1">
                {navItems.map((item) => (
                    <button
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        className={`flex flex-col items-center space-y-1 p-2 relative flex-1 min-w-0 group transition-colors duration-200 ${
                            location.pathname === item.path ? "text-red-600" : "text-gray-600"
                        }`}
                    >
                        <div className="relative">
                            {item.icon}
                        </div>
                        <span className="text-xs font-medium">
                            {item.label}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}